<ion-header>
    <ion-toolbar>
        <ion-title slot="start" class="toolbar-title">{{ 'ACCESS' | translate }}{{resourceType}} '{{resourceName}}'</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="cancel()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list class="without-margin">
        <ion-item>
            <ion-label>
                <ion-row class="ion-no-padding">
                    <ion-col class="ion-no-padding" style="max-width:200px">
                        <p>{{ allAccessItem[colName] }}</p>
                    </ion-col>
                    <ion-col class="ion-no-padding">
                        <p class="text-grey">{{ allAccessItem[colEmail] }}</p>
                    </ion-col>
                </ion-row>
            </ion-label>
            <ion-select [ngModel]="allAccessItem[colAccess2]" [interfaceOptions]="formatUser(allAccessItem)" (ionChange)="onAllAccessChange($event)" class="text-grey" [compareWith]="roleCompare">
                <ion-select-option value=2>{{ 'CAN_CHANGE_ACCESS' | translate }}</ion-select-option>
                <ion-select-option value=4>{{ 'CAN_ACCESS' | translate }}</ion-select-option>
                <ion-select-option value=0>{{ 'NO_ACCESS' | translate }}</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-grid class="ion-no-padding">            
            <ion-item *ngFor="let user of users">
                <ion-label>
                    <ion-row class="ion-no-padding">
                        <ion-col class="ion-no-padding" style="max-width:200px">
                            <p>{{ user[colName] }}</p>
                        </ion-col>
                        <ion-col class="ion-no-padding">
                            <p class="text-grey">{{ user[colEmail] }}</p>
                        </ion-col>
                    </ion-row>
                </ion-label>
                <ion-select [disabled]="isOwner(user)" [(ngModel)]="user[colAccess2]"  [interfaceOptions]="formatUser(user)" (ionChange)="onAccessChange(user, $event)" class="text-grey" [compareWith]="roleCompare">
                    <ion-select-option value=100>{{ 'FROM_EVERYONE' | translate }}</ion-select-option>
                    <ion-select-option [disabled]="!localUserIsOwner(user)" value=1>{{ 'IS_OWNER' | translate }}</ion-select-option>
                    <ion-select-option value=2>{{ 'CAN_CHANGE_ACCESS' | translate }}</ion-select-option>
                    <ion-select-option value=4>{{ 'CAN_ACCESS' | translate }}</ion-select-option>
                    <ion-select-option value=0>{{ 'NO_ACCESS' | translate }}</ion-select-option>
                </ion-select>
            </ion-item>            
        </ion-grid>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar color='light'>
        <ion-buttons slot="end">
            <ion-button (click)="done()" class="button-ok">{{ 'OK' | translate }}</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>




